<div class="sidenav" [ngClass]="{ 'sidenav-open': opened() }">
  <app-menu
    [parentClubLogo]="parentClubLogo()"
    (toggleLeftNav)="toggleLeftNav($event)"
    (logoutNavEventEmitter)="logout()"
  ></app-menu>
</div>

<ng-content></ng-content>
